import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ChevronLeft } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
interface Props {
  onContinue: () => void;
  onBack?: () => void;
}
export function OnboardingTechReveal({
  onContinue,
  onBack
}: Props) {
  const [mounted, setMounted] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50);
    return () => clearTimeout(timer);
  }, []);
  const totalSlides = 4;
  const currentSlide = 3;
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] relative overflow-hidden" data-id="element-814">
      {/* Top: Image */}
      <div className="relative w-full h-[45%] shrink-0" data-id="element-815">
        <img src="https://cdn.magicpatterns.com/uploads/tkDgtnk8Mw7a59DvebsvqK/pexels-mikhail-nilov-8543577.jpg" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover object-bottom" style={{
        opacity: mounted ? 1 : 0,
        transition: 'opacity 800ms cubic-bezier(0.4, 0, 0.2, 1)'
      }} data-id="element-816" />

        {/* Gradient fade to black at bottom */}
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'linear-gradient(to bottom, transparent 40%, #0D0D0D 100%)'
      }} data-id="element-817" />

        {/* Back button */}
        {onBack && <button onClick={onBack} aria-label="Back" className="absolute top-5 left-5 z-20 w-10 h-10 rounded-full bg-[#0D0D0D]/40 backdrop-blur-md flex items-center justify-center text-white/80 hover:text-white transition-colors" data-id="element-818">
            <ChevronLeft className="w-6 h-6 -ml-0.5" strokeWidth={2} data-id="element-819" />
          </button>}
      </div>

      {/* Bottom: Content */}
      <div className="flex-1 flex flex-col px-6 pb-8 pt-0" data-id="element-820">
        {/* Title */}
        <div className="flex-1 flex flex-col items-start justify-center" data-id="element-821">
          <span className="text-[12px] text-[#C5D82D] uppercase tracking-widest font-semibold mb-3" style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(16px)',
          transition: 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.16, 1, 0.3, 1)',
          transitionDelay: '150ms'
        }} data-id="element-822">
            L'impegno
          </span>
          <h1 className="text-white text-[24px] font-[500] leading-tight" style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(16px)',
          transition: 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.16, 1, 0.3, 1)',
          transitionDelay: '200ms'
        }} data-id="element-823">
            {'EIIS e il Comune di Roma pianteranno un albero per ogni connessione del Summit.\n'}
          </h1>
          <p className="text-[15px] text-[#A0A0A0] mt-3 leading-relaxed" style={{
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(16px)',
          transition: 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.16, 1, 0.3, 1)',
          transitionDelay: '300ms'
        }} data-id="element-824">
            {"Il tuo networking non resta un'email nella casella: lascia un segno vivo nell'ambiente.\n\n\n"}
          </p>
        </div>

        {/* Slide dots */}
        <div className="flex items-center justify-start gap-1.5 mb-6" style={{
        opacity: mounted ? 1 : 0,
        transition: 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)',
        transitionDelay: '400ms'
      }} data-id="element-825">
          {Array.from({
          length: totalSlides
        }).map((_, i) => <div key={i} className={`h-[5px] rounded-full transition-all duration-300 ${i === currentSlide ? 'w-6 bg-white' : 'w-[5px] bg-white/30'}`} data-id="element-826" />)}
        </div>

        {/* CTA */}
        <button onClick={onContinue} className="w-full py-4 rounded-full border-[1.5px] border-[#C5D82D] text-[#C5D82D] bg-transparent text-[14px] font-semibold tracking-wide flex items-center justify-center gap-2 transition-all duration-150 hover:bg-[#C5D82D]/10 active:bg-[#C5D82D]/20 active:scale-[0.98]" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.16, 1, 0.3, 1)',
        transitionDelay: '500ms'
      }} data-id="element-827">
          Iniziamo!
          <ArrowRightIcon className="w-4 h-4" strokeWidth={2} data-id="element-828" />
        </button>
      </div>
    </div>;
}